import { render, staticRenderFns } from "./Kiosks.vue?vue&type=template&id=28653a9e&"
import script from "./Kiosks.vue?vue&type=script&lang=js&"
export * from "./Kiosks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports